import React from 'react';
import _ from 'lodash';
import { getMessage } from './MessageUtils';
import { numFormat } from '@/pages/agency/utils/util';
import { MathUtil } from '@tencent/ptp-fe-common';

const { thousandsSeparated } = MathUtil;

export function renderEnumMessage(catalog) {
  return (type, name, value, data) => {
    if (type === 'head') {
      return value;
    }
    console.log(getMessage(data[name], catalog));
    return <span>{getMessage(data[name], catalog)}</span>;
  };
}

// 数字添加','分割，并保留2位小数
// eslint-disable-next-line max-len
export const thousandsSeparatedWithFix2ColumnRender = (_type, _name, value) => thousandsSeparatedWithFix2(value);

export const thousandsSeparatedWithFix2 = (value) => {
  if (value) {
    if (value > 0 && value < 0.01) {
      return '<0.01';
    }
    return thousandsSeparated(value, 2);
  }
  return value;
};

// 转成百分数
export const percentColumnRender = (_type, _name, value) => parsePercentValue(value);

export const parsePercentValue = (_value) => {
  const value = Number(_value);
  if (_.isFinite(value)) {
    if (value > 0 && value < 0.01) {
      return '<0.01%';
    }
    return `${value.toFixed(2)}%`;
  }
  return '-';
};

/**
 * @description: 处理默认Column
 */
export const renderDefaultColumn = (type, name, value, data) => {
  if (type === 'head') {
    return value;
  }
  if (value) return value;
  return '-';
};

/**
 * @description: 处理CustomerId展示
 */
export const renderCustomerId = (data) => {
  const { customerUnibdAppId, customerMpAppId, customerId } = data || {};
  const accountId = customerUnibdAppId ? customerUnibdAppId : customerMpAppId ? customerMpAppId : customerId;
  if (accountId) return accountId;
  return '-';
};

/**
 * @description: 处理跟进运营（lead, potential）
 */
export const renderFollowOperator = (type, name, value, data) => {
  if (type === 'head') {
    return value;
  }
  if (value) {
    let followOperator = '';
    value.map((v, i) => {
      return (followOperator += v + (i + 1 === value.length ? '' : ', '));
    });
    return followOperator;
  }
  return '-';
};

/**
 * @description: 首次充值金额
 */
export const rendeFirstChargeAmt = (money, str) => {
  if (money && typeof money === 'number') {
    return `${numFormat(money / 100, 2)} 元`;
  }
  return str || '-';
};
